import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-goods",
  "use": "icon-goods-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 20 20\" id=\"icon-goods\">\n\n<path class=\"st0\" d=\"M18.3,0H1.7C0.7,0,0,0.7,0,1.7v16.7C0,19.3,0.7,20,1.7,20h16.7c0.9,0,1.7-0.7,1.7-1.7V1.7C20,0.7,19.3,0,18.3,0\n\t M15.4,10.4C15,13,12.7,15,10,15c-2.7,0-5-2-5.4-4.6c-0.5-0.2-0.9-0.6-0.9-1.2c0-0.7,0.6-1.3,1.3-1.3s1.3,0.6,1.3,1.3\n\tc0,0.5-0.3,1-0.8,1.2c0.4,2.2,2.2,3.8,4.5,3.8s4.2-1.7,4.5-3.8c-0.5-0.2-0.8-0.7-0.8-1.2c0-0.7,0.6-1.3,1.3-1.3s1.3,0.6,1.3,1.3\n\tC16.3,9.7,15.9,10.2,15.4,10.4 M18.7,2.9c0,0.5-0.4,0.8-0.8,0.8H2.1c-0.5,0-0.8-0.4-0.8-0.8V2.1c0-0.5,0.4-0.8,0.8-0.8h15.8\n\tc0.5,0,0.8,0.4,0.8,0.8L18.7,2.9L18.7,2.9z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/goods.svg
// module id = XNJ4
// module chunks = 45